import { PropertyOwnershipStatus } from './AccountTypes';
import type { Coordinates } from './AccountTypes';

export enum ParcelProviderType {
  glide = 'GLIDE-Regrid',
  dtapi = 'DTAPI',
}

export const parcelProviderLabelsMap: Record<string, string> = {
  [ParcelProviderType.dtapi]: 'First American Data Tree',
  [ParcelProviderType.glide]: 'GLIDE Regrid',
};

export enum SearchType {
  fullAddress = 'FULLADDRESS',
  owner = 'OWNER',
  latlon = 'LATLONG',
}

export interface PropertyDetailRequest {
  ProductNames: string[];
  SearchType: SearchType;
  OwnerDetail?: {
    FirstName: string;
    LastName: string;
    City: string;
    ZipCode: string;
  };
  FullAddress?: string;
}

export interface PropertyTypeAttributes {
  usedesc?: string;
  lbcs_structure_desc?: string;
  numunits?: number;
  usecode?: string;
  landUse?: string;
  unitsResidential?: number;
}

export interface GetPropertyDetailsResponse {
  reportedCoordinates?: Coordinates;
  ownerNames?: string[];
  vestingOwner?: string;
  parcelCount?: number;
  property?: {
    address: string;
    city: string;
    state: string;
    zip: string;
  };
  response?: Record<any, any>;
  message?: string;
  parcelProvider?: ParcelProviderType;
  searchType?: SearchType;
  errors?: string[];
  propertyAttributes?: PropertyTypeAttributes;
}

export interface PropertyReport {
  id: string;
  applicationId?: string;
  parcelProvider?: ParcelProviderType;
  response?: {
    Reports?: Array<{
      Data?: any;
    }>;
  };
  result: {
    applicantMentionedAsOwner: boolean;
    propertyInExpectedLocation: boolean;
    status: PropertyOwnershipStatus;
    distanceBetween?: number;
    applicantName?: string;
  };
  createdAt: string;
}

export interface GlideReportDisplayValues {
  response?: {
    Reports?: Array<{
      Data?: {
        attributes?: {
          zoning_description?: string;
          lbcs_structure_desc?: string;
          lbcs_activity_desc?: string;
          zoning_type?: string;
          numstories?: number;
        };
      };
    }>;
  };
}

export interface DtapiReportDisplayValues {
  response?: {
    Reports?: Array<{
      Data?: {
        message?: string;
        SiteInformation?: {
          LandUse?: string;
          UnitsResidential?: number;
        };
        PropertyCharacteristics?: {
          NumberOfStories?: number;
        };
      };
    }>;
  };
}
